import { render, staticRenderFns } from "./bannerTable.vue?vue&type=template&id=44aaff4a"
import script from "./bannerTable.vue?vue&type=script&lang=js"
export * from "./bannerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports